import React from 'react';

const icons = {
  brain: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <path d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7Z" />
      <path d="M9 21h6M10 17v4M14 17v4M12 2v3" />
    </svg>
  ),
  chart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <path d="M3 3v18h18" />
      <path d="M7 16l4-8 4 4 5-9" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <path d="M12 2l8 4v6c0 5.25-3.5 9.74-8 11-4.5-1.26-8-5.75-8-11V6l8-4Z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  zap: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8Z" />
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z" />
    </svg>
  ),
  cog: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
    </svg>
  ),
  layers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <path d="M12 2L2 7l10 5 10-5-10-5Z" />
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
    </svg>
  ),
  lock: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  arrowRight: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  star: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  ),
  play: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
      <path d="M8 5v14l11-7L8 5z" />
    </svg>
  ),
  menu: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6">
      <path d="M3 12h18M3 6h18M3 18h18" />
    </svg>
  ),
  close: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  ),
  chevronDown: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <path d="M6 9l6 6 6-6" />
    </svg>
  ),

  /* ── Integration logos ── */
  integrationLogos: {
    Salesforce: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M20 8.5c2.1-2.2 5-3.5 8.2-3.5 4.4 0 8.2 2.5 10.1 6.2 1.5-.7 3.1-1 4.8-1C48.6 10.2 53 14.8 53 20.5c0 5.7-4.4 10.3-9.9 10.3-.7 0-1.3-.1-2-.2C39.4 34.3 36 37 32 37c-1.3 0-2.5-.3-3.6-.8C26.8 39.4 23.6 42 19.8 42c-3.2 0-6-1.7-7.6-4.3-.8.2-1.6.3-2.5.3C4.3 38 0 33.4 0 27.7c0-3.8 2-7.1 5-8.9-.3-1-.5-2.1-.5-3.2C4.5 10 9 5.5 14.5 5.5c2.2 0 4.2.7 5.5 3z" transform="scale(0.85) translate(4,4)" fill="#00A1E0"/>
      </svg>
    ),
    Snowflake: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <g transform="translate(24,24)" stroke="#29B5E8" strokeWidth="2.5" strokeLinecap="round">
          <line y1="-16" y2="16"/>
          <line y1="-16" y2="16" transform="rotate(60)"/>
          <line y1="-16" y2="16" transform="rotate(120)"/>
          <line x1="-4" y1="-14" x2="0" y2="-16"/><line x1="4" y1="-14" x2="0" y2="-16"/>
          <line x1="-4" y1="14" x2="0" y2="16"/><line x1="4" y1="14" x2="0" y2="16"/>
          <g transform="rotate(60)">
            <line x1="-4" y1="-14" x2="0" y2="-16"/><line x1="4" y1="-14" x2="0" y2="-16"/>
            <line x1="-4" y1="14" x2="0" y2="16"/><line x1="4" y1="14" x2="0" y2="16"/>
          </g>
          <g transform="rotate(120)">
            <line x1="-4" y1="-14" x2="0" y2="-16"/><line x1="4" y1="-14" x2="0" y2="-16"/>
            <line x1="-4" y1="14" x2="0" y2="16"/><line x1="4" y1="14" x2="0" y2="16"/>
          </g>
          <circle r="3" fill="#29B5E8"/>
          <circle cy="-10" r="2" fill="#29B5E8"/><circle cy="10" r="2" fill="#29B5E8"/>
          <circle cy="-10" r="2" fill="#29B5E8" transform="rotate(60)"/>
          <circle cy="10" r="2" fill="#29B5E8" transform="rotate(60)"/>
          <circle cy="-10" r="2" fill="#29B5E8" transform="rotate(120)"/>
          <circle cy="10" r="2" fill="#29B5E8" transform="rotate(120)"/>
        </g>
      </svg>
    ),
    AWS: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M13.5 26.4c0 .7.1 1.2.2 1.5.2.4.4.8.6 1.2.1.2.1.3.1.4 0 .2-.1.4-.4.5l-1.2.8c-.2.1-.3.2-.5.2-.2 0-.4-.1-.5-.3-.3-.3-.5-.7-.7-1-.2-.4-.4-.8-.6-1.3-1.6 1.9-3.6 2.8-6 2.8-1.7 0-3.1-.5-4.1-1.5s-1.5-2.3-1.5-3.9c0-1.7.6-3.1 1.9-4.2 1.3-1 2.9-1.5 5-1.5.7 0 1.4.1 2.2.2s1.5.3 2.3.5v-1.5c0-1.5-.3-2.6-1-3.3-.6-.7-1.7-1-3.3-1-.7 0-1.5.1-2.2.3-.8.2-1.5.5-2.2.8-.3.2-.6.3-.7.3-.15 0-.25-.1-.25-.4v-1c0-.2.03-.4.1-.5.07-.1.2-.3.5-.4.7-.4 1.6-.7 2.5-.9 1-.3 2-.4 3.1-.4 2.4 0 4.1.5 5.2 1.6s1.7 2.7 1.7 4.8v6.3z" transform="translate(10,6)" fill="#FF9900"/>
        <path d="M8.2 28.2c.6 0 1.3-.1 2-.3s1.3-.6 1.9-1.2c.4-.4.6-.8.8-1.3.1-.5.2-1.1.2-1.8v-.9c-.6-.2-1.2-.3-1.9-.4-.7-.1-1.3-.1-2-.1-1.4 0-2.3.3-3 .8-.6.5-1 1.3-1 2.3 0 .9.2 1.6.7 2.1.5.5 1.2.8 2.3.8z" transform="translate(10,6)" fill="#FF9900"/>
        <path d="M27.2 30.5c-.25 0-.4-.05-.5-.15-.15-.1-.25-.3-.35-.6l-3.9-12.8c-.1-.3-.15-.5-.15-.65 0-.25.13-.4.38-.4h1.9c.27 0 .45.05.55.15.13.1.22.3.3.6l2.8 11 2.6-11c.07-.3.15-.5.3-.6.12-.1.32-.15.55-.15h1.55c.27 0 .45.05.57.15.13.1.22.3.3.6l2.6 11.15L39.8 17c.1-.3.2-.5.32-.6.13-.1.32-.15.55-.15h1.8c.25 0 .4.13.4.4 0 .08-.02.15-.03.25-.02.1-.05.2-.12.42l-4 12.8c-.1.3-.2.5-.35.6-.15.1-.35.15-.55.15h-1.7c-.27 0-.45-.05-.57-.15-.12-.12-.22-.3-.3-.63l-2.55-10.7-2.5 10.68c-.08.3-.18.5-.3.63s-.33.15-.58.15h-1.7z" transform="translate(0,6)" fill="#FF9900"/>
        <path d="M2.2 36.8C7.5 40.7 15 42.8 21.3 42.8c8.7 0 16.5-3.2 22.4-8.5.5-.45.05-.95-.55-.65-6.4 3.7-14.2 5.95-22.3 5.95-5.4 0-11.4-1.1-16.9-3.45-.8-.37-1.5.5-.75 1.15z" fill="#FF9900"/>
        <path d="M.3 34.5c-.7-.85-.1-6.75.35-9.2.08-.4.4-.3.38.05-.35 2.3.4 7.2 1.1 8.15.7.9-.55 1.8-1.2 1.55" transform="translate(0,2)" fill="#FF9900"/>
      </svg>
    ),
    Azure: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M17.8 4L5 37.4h9.3L17.8 4z" fill="#0089D6"/>
        <path d="M14.3 37.4L30 33.5l-7.5-8.9L14.3 37.4z" fill="#0089D6"/>
        <path d="M22.5 24.6L30 33.5 43 37.4 17.8 4l4.7 20.6z" fill="#3CCBF4"/>
        <path d="M14.3 37.4H43L30 33.5l-15.7 3.9z" fill="#0089D6" opacity="0.8"/>
      </svg>
    ),
    'Google Cloud': (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M30.6 12.3l3.3-3.3.2-1.4C30 4 24.2 2.5 18.7 4.2c-5.5 1.7-9.8 6.1-11.3 11.7l1.2-.2 6.6-1.1.5-.5c2.6-2.9 6.6-4 10.2-3l.2.1 4.5-4.5z" fill="#EA4335"/>
        <path d="M39 16c-1.1-4-3.6-7.5-7-9.8L26.5 12c3 2.2 4.8 5.7 4.8 9.5v1.2c3.3 0 6 2.7 6 6s-2.7 6-6 6H24l-1.2 1.2v7.2l1.2 1.2h7.3c7 0 12.6-5.7 12.6-12.6 0-5.2-3.2-9.9-7.9-11.7z" fill="#4285F4"/>
        <path d="M16.7 44.3h7.3V37.7h-7.3c-.85 0-1.7-.18-2.5-.5l-1.7.53-3.3 3.3-.4 1.7c2.3 1.1 4.9 1.6 7.9 1.6z" fill="#34A853"/>
        <path d="M16.7 19.1c-7 0-12.6 5.7-12.6 12.6 0 4.7 2.5 8.8 6.4 11l5.5-5.5c-3-.6-5.3-3.2-5.3-6.4 0-3.3 2.7-6 6-6s6 2.7 6 6l5.4-5.4c-2.2-3.8-6.3-6.3-11.4-6.3z" fill="#FBBC05"/>
      </svg>
    ),
    Databricks: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M24 2L4 14v6l20 12 20-12v-6L24 2z" fill="#FF3621"/>
        <path d="M4 20v6l20 12 20-12v-6L24 32 4 20z" fill="#FF3621" opacity="0.7"/>
        <path d="M4 26v6l20 12 20-12v-6L24 38 4 26z" fill="#FF3621" opacity="0.4"/>
      </svg>
    ),
    Slack: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M12 28a4 4 0 1 1 0-8h4v4a4 4 0 0 1-4 4zm0 0" fill="#E01E5A"/>
        <path d="M16 20a4 4 0 0 1 4-4h4v4a4 4 0 0 1-4 4h-4v-4z" fill="#E01E5A"/>
        <path d="M28 12a4 4 0 1 1-8 0v-4h4a4 4 0 0 1 4 4zm0 0" fill="#36C5F0"/>
        <path d="M20 16a4 4 0 0 1-4-4V8h4a4 4 0 0 1 4 4v4h-4z" fill="#36C5F0"/>
        <path d="M36 20a4 4 0 1 1 0 8h-4v-4a4 4 0 0 1 4-4zm0 0" fill="#2EB67D"/>
        <path d="M32 28a4 4 0 0 1-4 4h-4v-4a4 4 0 0 1 4-4h4v4z" fill="#2EB67D"/>
        <path d="M20 36a4 4 0 1 1 8 0v4h-4a4 4 0 0 1-4-4zm0 0" fill="#ECB22E"/>
        <path d="M28 32a4 4 0 0 1 4 4v4h-4a4 4 0 0 1-4-4v-4h4z" fill="#ECB22E"/>
      </svg>
    ),
    Tableau: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <g fill="#E97627">
          <rect x="22" y="2" width="4" height="8"/>
          <rect x="18" y="6" width="12" height="4" rx="0"/>
          <rect x="22" y="38" width="4" height="8"/>
          <rect x="18" y="38" width="12" height="4"/>
          <rect x="2" y="22" width="8" height="4"/>
          <rect x="6" y="18" width="4" height="12"/>
          <rect x="38" y="22" width="8" height="4"/>
          <rect x="38" y="18" width="4" height="12"/>
        </g>
        <g fill="#C72037">
          <rect x="22" y="18" width="4" height="12"/>
          <rect x="18" y="22" width="12" height="4"/>
        </g>
        <g fill="#5B879B" opacity="0.8">
          <rect x="10" y="10" width="3" height="8"/>
          <rect x="7" y="13" width="9" height="3"/>
          <rect x="35" y="10" width="3" height="8"/>
          <rect x="32" y="13" width="9" height="3"/>
          <rect x="10" y="30" width="3" height="8"/>
          <rect x="7" y="33" width="9" height="3"/>
          <rect x="35" y="30" width="3" height="8"/>
          <rect x="32" y="33" width="9" height="3"/>
        </g>
      </svg>
    ),
    PostgreSQL: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M34.7 8.5C32 6 28.3 4.5 24 4.5c-8.6 0-15.5 5.8-15.5 14.5 0 4.5 1.5 8 4.5 10.7 0 0 .5 5 1 8.5.4 2.5 2 3.3 3.5 3.3h2c1 0 2-.7 2-2.2l.2-3.8c1 .2 2.2.3 3.3.3" stroke="#336791" strokeWidth="2.5" fill="none"/>
        <ellipse cx="32" cy="18" rx="8" ry="12" stroke="#336791" strokeWidth="2.5" fill="none"/>
        <path d="M28 30c1 3 1.5 7 2 9.5.3 1.5 1.5 2 2.5 2h2c1.5 0 2.5-1 2.8-2.5.5-3 1-5 1.2-8" stroke="#336791" strokeWidth="2.5" fill="none"/>
        <circle cx="19" cy="16" r="2" fill="#336791"/>
        <circle cx="29" cy="16" r="2" fill="#336791"/>
      </svg>
    ),
    MongoDB: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M24 4c-1 4-3 7-6 10-4 4-5 8-5 13 0 8 5 15 11 17v-4c0-1 0-2 .5-2.5V4z" fill="#4FAA41"/>
        <path d="M24 4c1 4 3 7 6 10 4 4 5 8 5 13 0 8-5 15-11 17v-4c0-1 0-2-.5-2.5V4z" fill="#3F9C35"/>
        <rect x="22.5" y="36" width="3" height="8" rx="1.5" fill="#89D75F"/>
      </svg>
    ),
    Kafka: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <circle cx="24" cy="24" r="4" fill="#231F20"/>
        <circle cx="24" cy="12" r="3.5" fill="#231F20"/>
        <circle cx="24" cy="36" r="3.5" fill="#231F20"/>
        <circle cx="34" cy="18" r="3.5" fill="#231F20"/>
        <circle cx="14" cy="30" r="3.5" fill="#231F20"/>
        <circle cx="34" cy="30" r="3.5" fill="#231F20"/>
        <circle cx="14" cy="18" r="3.5" fill="#231F20"/>
        <line x1="24" y1="20" x2="24" y2="15.5" stroke="#231F20" strokeWidth="2"/>
        <line x1="24" y1="28" x2="24" y2="32.5" stroke="#231F20" strokeWidth="2"/>
        <line x1="27.5" y1="22" x2="31" y2="19.5" stroke="#231F20" strokeWidth="2"/>
        <line x1="20.5" y1="26" x2="17" y2="28.5" stroke="#231F20" strokeWidth="2"/>
        <line x1="27.5" y1="26" x2="31" y2="28.5" stroke="#231F20" strokeWidth="2"/>
        <line x1="20.5" y1="22" x2="17" y2="19.5" stroke="#231F20" strokeWidth="2"/>
      </svg>
    ),
    Kubernetes: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M24 4L6 14v20l18 10 18-10V14L24 4z" fill="#326CE5" stroke="#326CE5" strokeWidth="1"/>
        <g stroke="white" strokeWidth="1.5" fill="none">
          <circle cx="24" cy="24" r="8"/>
          <line x1="24" y1="16" x2="24" y2="12"/>
          <line x1="24" y1="36" x2="24" y2="32"/>
          <line x1="17" y1="20" x2="13.5" y2="18"/>
          <line x1="31" y1="28" x2="34.5" y2="30"/>
          <line x1="31" y1="20" x2="34.5" y2="18"/>
          <line x1="17" y1="28" x2="13.5" y2="30"/>
        </g>
        <circle cx="24" cy="24" r="2.5" fill="white"/>
      </svg>
    ),
    Docker: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M46 20.3c-.7-.5-2.3-1-4.2-.8-.2-1.6-1-3-2.6-4.2l-.9-.6-.6.8c-.8 1.2-1.2 2.8-1.1 4.3.1.8.3 1.7.8 2.4-.6.3-1.2.6-1.9.8-1.2.3-2.4.5-3.6.5H2.1l-.1.8c-.2 2.3.1 4.7 1 6.8 1.1 2.4 2.7 4 4.9 5 2.5 1.1 6.5 1.7 11 .1 3.3-1.2 6.2-3.2 8.5-6.2 1.9-2.4 3-5.1 3.6-8h.6c2.2 0 3.6-.9 4.4-1.6.5-.5.9-1 1.2-1.6l.2-.5-.8-.5z" fill="#2496ED"/>
        <g fill="#2496ED">
          <rect x="8" y="18" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
          <rect x="14.5" y="18" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
          <rect x="21" y="18" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
          <rect x="14.5" y="12.5" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
          <rect x="21" y="12.5" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
          <rect x="27.5" y="18" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
          <rect x="21" y="7" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
          <rect x="8" y="12.5" width="5" height="4.5" rx=".5" stroke="white" strokeWidth=".8"/>
        </g>
      </svg>
    ),
    Terraform: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M17.4 4v13.8L29 24.6V10.8L17.4 4z" fill="#5C4EE5"/>
        <path d="M30.6 10.8v13.8L42.2 18V4.1L30.6 10.8z" fill="#5C4EE5"/>
        <path d="M4 11.1v13.8l11.6 6.8V17.9L4 11.1z" fill="#4040B2"/>
        <path d="M17.4 32.3v13.8L29 39.3V25.5l-11.6 6.8z" fill="#5C4EE5"/>
      </svg>
    ),
    GitHub: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M24 4C12.95 4 4 12.95 4 24c0 8.84 5.73 16.34 13.68 18.98 1 .18 1.37-.43 1.37-.96 0-.47-.02-2.04-.03-3.7-5.56 1.21-6.73-2.35-6.73-2.35-.91-2.31-2.22-2.92-2.22-2.92-1.81-1.24.14-1.21.14-1.21 2 .14 3.06 2.06 3.06 2.06 1.78 3.05 4.67 2.17 5.81 1.66.18-1.29.7-2.17 1.27-2.67-4.44-.5-9.1-2.22-9.1-9.88 0-2.18.78-3.97 2.06-5.37-.21-.5-.89-2.54.19-5.29 0 0 1.68-.54 5.5 2.05A19.15 19.15 0 0 1 24 13.2c1.7.01 3.41.23 5.01.68 3.82-2.59 5.49-2.05 5.49-2.05 1.09 2.75.41 4.79.2 5.29 1.28 1.4 2.05 3.19 2.05 5.37 0 7.68-4.67 9.37-9.12 9.87.72.62 1.36 1.84 1.36 3.7 0 2.67-.02 4.83-.02 5.49 0 .53.36 1.15 1.38.96C38.28 40.33 44 32.84 44 24 44 12.95 35.05 4 24 4z" fill="white"/>
      </svg>
    ),
    Jira: (
      <svg viewBox="0 0 48 48" fill="none" className="w-full h-full">
        <path d="M44.7 22.6L26.1 4 24 1.9 9.5 16.4l-6.2 6.2c-.7.7-.7 1.9 0 2.6L16.8 38.7 24 45.9l14.5-14.5.5-.5 5.7-5.7c.7-.7.7-1.9 0-2.6zM24 31L17 24l7-7 7 7-7 7z" fill="#2684FF"/>
        <path d="M24 17c-3.9-3.9-3.9-10.1-.1-14L9.5 17.4l7 7L24 17z" fill="url(#jira_a)" opacity="0.8"/>
        <path d="M31 24l-7 7c3.9 3.9 3.9 10.2 0 14.1L38.5 30.6l-7.5-6.6z" fill="url(#jira_b)" opacity="0.8"/>
        <defs>
          <linearGradient id="jira_a" x1="22.2" y1="10.3" x2="13.2" y2="19.3">
            <stop stopColor="#0052CC"/><stop offset="1" stopColor="#2684FF"/>
          </linearGradient>
          <linearGradient id="jira_b" x1="25.9" y1="37.6" x2="34.9" y2="28.6">
            <stop stopColor="#0052CC"/><stop offset="1" stopColor="#2684FF"/>
          </linearGradient>
        </defs>
      </svg>
    ),
  },
};

export default icons;
